import { render, staticRenderFns } from "./AddFbaDialog.vue?vue&type=template&id=d906558e&scoped=true"
import script from "./AddFbaDialog.vue?vue&type=script&lang=js"
export * from "./AddFbaDialog.vue?vue&type=script&lang=js"
import style0 from "./AddFbaDialog.vue?vue&type=style&index=0&id=d906558e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d906558e",
  null
  
)

export default component.exports